/**
 * The text color corresponding to Figma tokens.
 * ```
 * - `strong`   - Represents the token `color/ref/text/strong`       ` #FFFFFF`
 * - `disabled` - Represents the token `color/ref/text/disabled`     ` #4E5055`
 * - `muted`    - Represents the token `color/ref/text/muted`        ` #a2a4a9`
 * - `accent`   - Represents the token `color/ref/text/accent`       ` #03bfac`
 * - `inverted` - Represents the token `color/ref/text/inverted`     ` #000000`
 * - `default`  - Represents the token `color/ref/ui/status/default` ` #a2a4a9`
 * - `danger`   - Represents the token `color/ref/ui/status/danger`  ` #e8646f`
 * - `success`  - Represents the token `color/ref/ui/status/success` ` #79d297`
 * - `info`     - Represents the token `color/ref/ui/status/info`    ` #5580f6`
 * - `warning`  - Represents the token `color/ref/ui/status/warning` ` #ebb128`
 * - `alert`    - Represents the token `color/ref/ui/status/alert`   ` #ff7d52`
 * ```
 */
export type TextColors =
  | 'strong'
  | 'muted'
  | 'disabled'
  | 'accent'
  | 'danger'
  | 'success'
  | 'inverted'
  | 'default'
  | 'info'
  | 'warning'
  | 'alert'
  | 'link';

export const textColorMapping: { [key in TextColors]: string } = {
  strong: 'text-color-ref-text-strong',
  muted: 'text-color-ref-text-muted',
  disabled: 'text-color-ref-text-disabled',
  accent: 'text-color-ref-text-accent',
  inverted: 'text-color-ref-text-inverted',
  default: 'text-color-ref-ui-status-default',
  danger: 'text-color-ref-ui-status-danger',
  success: 'text-color-ref-ui-status-success',
  info: 'text-color-ref-ui-status-info',
  warning: 'text-color-ref-ui-status-warning',
  alert: 'text-color-ref-ui-status-alert',
  link: 'text-color-ref-text-link-primary',
};

// These are for charts that use svg text
export const textFillMapping: { [key in TextColors]: string } = {
  strong: 'fill-color-ref-text-strong',
  muted: 'fill-color-ref-text-muted',
  disabled: 'fill-color-ref-text-disabled',
  accent: 'fill-color-ref-text-accent',
  inverted: 'fill-color-ref-text-inverted',
  default: 'fill-color-ref-ui-status-default',
  danger: 'fill-color-ref-ui-status-danger',
  success: 'fill-color-ref-ui-status-success',
  info: 'fill-color-ref-ui-status-info',
  warning: 'fill-color-ref-ui-status-warning',
  alert: 'fill-color-ref-ui-status-alert',
  link: 'fill-color-ref-text-link-primary',
};
